import styled, { css } from 'styled-components'
import { Modal } from 'antd'

export const ModalRelease = styled(Modal)`

 
`

export const FormActionFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin: 30px 0;
`


export const SelectList = styled.div`
  ul {
    li {
      font-size: 10.5px;
      text-transform: capitalize;
    }

    span {
      width: 20px;
      height: 20px;
    }
  }
`
export const SelectTitle = styled.div`
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
`

export const UploadFileListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  transition: all ease .3s;
  padding: 3px 0;
  border-bottom: 1px solid #ebebeb;


  .digital-signature, .rename {
    color: #1890FF;
    font-size: 12px;
    opacity: 0.8;

    &:hover {
      opacity: 1;

      span {
        text-decoration-line: underline;
      }
    }
  }

  .digital-signature {
    ${props => props.isNotPDF ? css`
      cursor: no-drop !important;
      color: #ccc !important;
    ` : css`
      cursor: pointer;
    `}
    ${props => props.isSigned ? css`
      color: #2ecc71;
      cursor: no-drop;
    ` : css`
      cursor: pointer;
      color: #1890FF;
    `}
  }

  .rename {
    ${props => props.isSigned ? css`
      cursor: no-drop;
      color: #ccc;
    ` : css`
      cursor: pointer;
    `}
  }

  .anticon-check, .anticon-delete {
    transition: all ease .3s;
    color: red;
    font-size: 12px;

    &:hover {
      cursor: pointer;
    }
  }

  .ant-tag {
    cursor: pointer;
    padding: 2px 13px;
  }

  .anticon-paper-clip {
    margin: 0 8px 0 5px;
    color: ${props => !props.isSigned ? 'rgba(0, 0, 0, 0.85)' : '#1890ff'};

    + span {
      flex-grow: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: auto;
      padding-right: 60px;
      color: ${props => !props.isSigned ? 'rgba(0, 0, 0, 0.85)' : '#1890ff'};
    }
  }
`
export const UploadFileListWrapper = styled.ul`
  margin-bottom: 15px;
  padding-left: 0 !important;
`